import { SalesOrderItemResult } from "../../financial-satatement/sales-order-item-result";
import { ProductItem } from "../../transactional-management/product-item";
import { AuditSale } from "./audit-sale";

/**
 * Atenção! Esta classe extends AuditSale, ou seja, contém tudo que tem lá porém com
 * a propriedade "items" a mais
 */
export class AuditSaleDetails extends AuditSale {
  private items: Array<ProductItem>;

  constructor() {
    super();
    this.items = new Array<ProductItem>();
  }

  public getItems(): Array<ProductItem> {
    return this.items;
  }

  public setItems(items: Array<ProductItem>): void {
    this.items = items;
  }

  setAuditSaleProperts(auditSale: AuditSale) {
    this.setSalesOrderKey(auditSale.getSalesOrderKey());
    this.setUniqueSequentialNumber(auditSale.getUniqueSequentialNumber());
    this.setUniqueSequentialNumberCorrelated(auditSale.getUniqueSequentialNumberCorrelated());
    this.setBeneficiary(auditSale.getBeneficiary());
    this.setTransactionDate(auditSale.getTransactionDate());
    this.setSalesAction(auditSale.getSalesAction());
    this.setNetworkInfo(auditSale.getNetworkInfo());
    this.setErrorCauses(auditSale.getErrorCauses());
    this.setStatus(auditSale.getStatus());
    this.setSource(auditSale.getSource());
    this.setHasPendingMedicalPrescriptionScans(auditSale.getHasPendingMedicalPrescriptionScans());
  }
}
